var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"default-content"},[_c('p',{staticStyle:{"font-size":"xx-large"}},[_vm._v("暂无数据")]),_c('p',{staticStyle:{"font-size":"large"}},[_vm._v("请点击左侧生成客户数据")])])
}]

export { render, staticRenderFns }